import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import StoreBadges from '../../components/Shared/StoreBadges';
import { STORE_LINKS } from '../../utils/platform';

const Testi = ({ platform }) => {
  const isDesktop = platform === 'desktop';

  return (
    <React.Fragment>
      <section className="section pt-0">
        <Container className="px-4 px-md-3 px-lg-0">
          <Row className="mt-md-5 pt-md-3 mt-4 pt-2 mt-sm-0 pt-sm-0 justify-content-center">
            <Col xs="12" className="text-center">
              <div className="section-title">
                <h4 className="title mb-4">Start Building Your Vocabulary Today</h4>
                {isDesktop ? (
                  <>
                    <p className="text-muted para-desc mx-auto">
                      <span className="text-primary fw-bold">HighVocab</span> is free
                      to install. Add it to your browser and start saving words from
                      the very first page you visit.
                    </p>
                    <div className="mt-4 pt-2 d-flex flex-column flex-sm-row justify-content-center align-items-center gap-3">
                      <a
                        href={STORE_LINKS.chrome}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-primary w-100 w-sm-auto"
                        style={{ maxWidth: 320 }}
                      >
                        Add to Chrome — It's Free <i className="mdi mdi-arrow-right"></i>
                      </a>
                      <a
                        href={STORE_LINKS.edge}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-outline-primary w-100 w-sm-auto"
                        style={{ maxWidth: 320 }}
                      >
                        Install on Edge
                      </a>
                    </div>
                  </>
                ) : (
                  <>
                    <p className="text-muted para-desc mx-auto">
                      <span className="text-primary fw-bold">HighVocab</span> is free
                      to start. Download the app and save your first word today.
                    </p>
                    <div className="mt-4">
                      <StoreBadges platform={platform} />
                    </div>
                  </>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};
export default Testi;
